(function () {
	'use strict';
	angular.module('app.core')
    .service('drilldownFunctionsService', drilldownFunctionsService);

	drilldownFunctionsService.$inject = ['$window', '$experiments', 'URLS', 'leanFilterService', 'localStorageService', 'storeService'];

	function drilldownFunctionsService($window, $experiments, URLS, leanFilterService, localStorageService, storeService) {

		return {
			makeDrilldownParamString: makeDrilldownParamString,
			makeSelectFilter: makeSelectFilter,
			makeRangeFilter: makeRangeFilter,
			openLatePrCountDrilldown: openLatePrCountDrilldown,
			getReportDrilldownUrl: getReportDrilldownUrl,
			getDrilldownParamArray: getDrilldownParamArray,
			getMinimalFilterFromReportSettings: getMinimalFilterFromReportSettings
		};


		function makeSelectFilter(id, values, unselectedValues) {
			if (unselectedValues) {
				return {
					id: id,
					unselectedValues: Array.isArray(unselectedValues) ? unselectedValues : [unselectedValues]
				};
			}
			return {
				id: id,
				values: Array.isArray(values) ? values : [values]
			};
		}

		function makeRangeFilter(id, comparator, valueOne, valueTwo) {
			return {
				id: id,
				comparator: comparator,
				valueOne: valueOne,
				valueTwo: valueTwo
			};
		}

		function getMinimalFilterFromReportSettings(filter) {
			return {
				id: filter.id,
				values: filter.values,
				unselectedValues: filter.unselectedValues,
				valueOne: filter.valueOne,
				valueTwo: filter.valueTwo,
				comparator: filter.comparator,
				value: filter.value
			};
		}

		function hash(string) {
			var hash = 0;
			var i;
			var chr;
			if (string.length === 0) return hash;
			for (i = 0; i < string.length; i++) {
				chr = string.charCodeAt(i);
				hash = ((hash << 5) - hash) + chr;
				hash |= 0; // Convert to 32bit integer
			}
			return hash;
		}

		function makeDrilldownId(params) {
			return 'drilldown' + hash(JSON.stringify(params));
		}

		function getDropdownFilters() {
			return  leanFilterService.masterFilterList.concat(leanFilterService.masterSingleSelectFilterList).map(function(f) {
				return f.id;
			});
		}
		function makeDrilldownParamString(drilldownFilters, isUseReportFilters, drilldownSorters, drilldownSearch, mandatoryColumnList, persistSettings, drilldownFrom, drilldownSearchOperator, adminParams, dashboardType, kpiDrilldownSettings, drilldownConfig) {
			var params = {};
			var filters = [];
			var dropdownFilterIds = getDropdownFilters();
			var isNestedSearch = false;
			if (isUseReportFilters) {
				filters = storeService.getState().reportSettings.filters.map(function (filter) {
					var filterObject = getMinimalFilterFromReportSettings(filter);
					if (filterObject.id === 'factory') {
						// Factory needs to be treated differently
						filterObject.values = leanFilterService.getFactoryList().split(',');
					}
					return filterObject;
				});
				params.filters = filters;
			}
			if (drilldownFilters) {
				var drilldownFilterIds = drilldownFilters.map(function (filter) {
					return filter.id;
				});
				filters = filters.filter(function (filter) {
					return !drilldownFilterIds.includes(filter.id);
				});
				params.filters = filters.concat(drilldownFilters).filter(function(filter) {
					if (dropdownFilterIds.indexOf(filter.id) !== -1) {
						return (filter.values && filter.values.length !== 0) || (filter.unselectedValues && filter.unselectedValues.length !== 0);
					}
					return true;
				}).map(function(filter) {
					if (filter.id === 'planners') {
						filter.id = 'planner';
					} else if (filter.id === 'businessunit') {
						filter.id = 'businessUnit';
					}
					var values = filter.values;
					if (values && Array.isArray(values)) {
						if (values.length === 1 &&
							typeof values[0] === 'string' &&
							values[0].includes(',')
						) {
							filter.values = values[0].split(',');
						} else {
							var allNumbers = values.every(function (value) {
								return value && typeof value === 'number';
							});
							if (allNumbers) {
								filter.values = filter.values.map(function (value) {
									return value + '';
								});
							}
						}
					}
					return filter;
				});
				if(drilldownSearch != null && typeof drilldownSearch === 'object' && drilldownSearch.id && drilldownSearch.id === 'parentAssemblyNestedSearch'){
					params.filters.push(drilldownSearch);
					isNestedSearch = true;
				}
			}
			if (persistSettings) params.persistSettings = persistSettings;
			if (drilldownFrom) params.drilldownFrom = drilldownFrom;
			if (drilldownSorters) params.sorters = drilldownSorters;
			if (drilldownSearch && !isNestedSearch) params.search = drilldownSearch;
			if (drilldownSearchOperator && !isNestedSearch) params.searchOperator = drilldownSearchOperator;
			if (mandatoryColumnList) params.mandatoryColumns = mandatoryColumnList;
			if (adminParams) params.adminParams = adminParams;
			if (kpiDrilldownSettings) params.kpiDrilldownSettings = kpiDrilldownSettings;
			if (drilldownConfig) params.config = drilldownConfig;
			var encodedParams = encodeURIComponent(JSON.stringify(params));

			// a "safe" max URL length is 2000 chars, 1800 allows for 200 chars in base url
			var maxDrilldownParamsCharacterLength = 1800;
			var drilldownString;
			if (encodedParams.length > maxDrilldownParamsCharacterLength) {
				var drilldownId = makeDrilldownId(params);
				localStorageService.set(drilldownId, params);
				drilldownString = '?drilldownSettings=' + encodeURIComponent(JSON.stringify({ id: drilldownId }));
			} else {
				drilldownString = '?drilldownSettings=' + encodedParams;
			}
			if(dashboardType) {
				drilldownString += '&dashboardType=' + dashboardType;
			}
			return drilldownString;
		}

		function getLatePRCountDrilldownReactParams(viewType, isTotalRow, leanDirFactoryNdxs, identifierDisplay, buyer) {
			var comparators = leanFilterService.comparatorsMap;
			var drilldownFilters = [];
			var factoryId = 'factory';
			var itemGroupId = 'itemGroupNdx';
			var buyerId = 'buyerCode';
			drilldownFilters.push(makeRangeFilter('daysUntilPOFirm', comparators.lessThanOrEqual, -1));
			if (viewType === 'site') {
				var selectedFactories = isTotalRow ? leanFilterService.getSelectedIds('factory') : leanDirFactoryNdxs;
				drilldownFilters.push(makeSelectFilter(factoryId, selectedFactories));
			} else if (viewType === 'itemGroup') {
				drilldownFilters.push(makeSelectFilter(factoryId, leanFilterService.getSelectedIds('factory')));
				var selectedItemGroups = isTotalRow ? leanFilterService.getSelectedIds('itemGroupNdx') : identifierDisplay;
				drilldownFilters.push(makeSelectFilter(itemGroupId, selectedItemGroups));
			} else {
				drilldownFilters.push(makeSelectFilter(factoryId, leanFilterService.getSelectedIds('factory')));
				drilldownFilters.push(makeSelectFilter(itemGroupId, leanFilterService.getSelectedIds('itemGroupNdx')));
				var selectedBuyers = isTotalRow ? leanFilterService.getSelectedIds('buyerCode') : buyer;
				drilldownFilters.push(makeSelectFilter(buyerId, selectedBuyers));
			}
			return makeDrilldownParamString(drilldownFilters, false);
		}
		function openLatePrCountDrilldown(viewType, isTotal, leanDirFactoryNdxs, identifierDisplay, buyer) {
			var purchaseRequisitionsUrl = URLS.frontendPrefix + 'supply-chain/purchase-requisitions/';
			var href = purchaseRequisitionsUrl + getLatePRCountDrilldownReactParams(viewType, isTotal, leanDirFactoryNdxs, identifierDisplay, buyer);
			$window.open(href, '_blank');
		}
		function getReportDrilldownUrl(reportPath, targetReportExperimentFlag, paramObject, isReactLeanTable) {
			if ((targetReportExperimentFlag && $experiments.isEnabled(targetReportExperimentFlag)) || isReactLeanTable) {
				var drilldownFilters = [];
				var sorters = [];
				var search;
				var searchOperator;
				var dashboardType;
				var adminParams;
				var persistSettings = paramObject.persistSettings;
				var drilldownFrom = paramObject.drilldownFrom;
				var kpiDrilldownSettings;
				var drilldownConfig;

				if (paramObject.reactParams) {
					drilldownFilters = paramObject.reactParams.filters;
					sorters = paramObject.reactParams.sorters;
					search = paramObject.reactParams.search;
					if (paramObject.reactParams.kpiDrilldownSettings) {
						kpiDrilldownSettings = paramObject.reactParams.kpiDrilldownSettings;
					}
					if (paramObject.reactParams.config) {
						drilldownConfig = paramObject.reactParams.config;
					}
					if (paramObject.reactParams.dashboardType) {
						dashboardType = paramObject.reactParams.dashboardType;
					}
					if (paramObject.reactParams.searchOperator) {
						searchOperator = paramObject.reactParams.searchOperator;
					}
					if (paramObject.reactParams.adminFactory) {
						adminParams = paramObject.reactParams.adminFactory;
					}
				} else {
					_.forEach(_.omit(paramObject, ['search', 'searchOperator', 'sort', 'sortDesc', 'sorters', 'persistSettings', 'drilldownFrom', 'adminFactory', 'autoOpenComplianceDrawer']), function(value, key) {
						if (value != null) {
							if (_.get(value, 'filterType', false) && value.filterType === 'rangeFilter') {
								drilldownFilters.push(makeRangeFilter(key, value.comparator, value.valueOne, value.valueTwo));
							} else if (value === 'true' || value === 'false') {
								drilldownFilters.push({ id: key, value: value });
							} else {
								if (_.get(value, 'useUnselected', false) && value.unselectedValues) {
									drilldownFilters.push(makeSelectFilter(key, null, Array.isArray(value.unselectedValues) ? value.unselectedValues: [value.unselectedValues]));
								} else {
									drilldownFilters.push(makeSelectFilter(key, Array.isArray(value) ? value: [value]));
								}
							}
						}
					});
					sorters = getSorters(paramObject);
					search = paramObject.search;
					if (paramObject.searchOperator) {
						searchOperator = paramObject.searchOperator;
					}
					if (paramObject.adminFactory) {
						adminParams = paramObject.adminFactory;
					}
					if (paramObject.autoOpenComplianceDrawer) {
						drilldownConfig = { 
							autoOpenComplianceDrawer: paramObject.autoOpenComplianceDrawer
						};
					}
				}
				return URLS.frontendPrefix + reportPath + makeDrilldownParamString(drilldownFilters, false, sorters, search, null, persistSettings, drilldownFrom, searchOperator, adminParams, dashboardType, kpiDrilldownSettings, drilldownConfig);
			}
			Object.keys(paramObject).forEach(function (key) {
				if (paramObject[key] == null || key === 'reactParams') {
					delete paramObject[key];
				}
			});
			var params = new URLSearchParams(paramObject);
			return URLS.frontendPrefix + reportPath + '?drilldown=1&' + params.toString();
		}

		function getSorters(paramObject) {
			var sorters = _.get(paramObject, 'sorters', null);
			if (!!sorters) {
				return sorters;
			} else {
				var property = _.get(paramObject, 'sort', null);
				if (property) {
					var isDesc = _.get(paramObject, 'sortDesc', null);
					var direction = isDesc ? 'DESC' : 'ASC';
					return [{ property: property, direction: direction }];
				}
			}
		}

		function getDrilldownParamArray(filtersObj) {
			return Object.keys(filtersObj).map(function (filterKey) {
				var filterValue = filtersObj[filterKey];
				var isObject = typeof filterValue === 'object';
				if (isObject) {
					filterValue.id = filterKey;
					return filterValue;
				} else {
					return makeSelectFilter(filterKey, filterValue);
				}
			});
		}
	}
})();
